import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING } from "const"
import {
    useInput,
    StateType,
} from "client/utils"
import {
    StoreType,
    CheckPasswordRestrictions,
    EncryptUserPassword,
    ChangeUserPassword,
    LoadUserById,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

let isMounted: boolean

const ChangePassword = () => {
    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [oldPassword, setOldPassword] = useInput("")
    const [newPassword, setNewPassword] = useInput("")
    const [repeatNewPassword, setRepeatNewPassword] = useInput("")

    const [oldPasswordWrong, setOldPasswordWrong] = useState(false)
    const [passwordMismatch, setPasswordMismatch] = useState(false)
    const [passwordRestrictions, setPasswordRestrictions] = useState(true)

    const [confirmState, setConfirmState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return
        if (modals.length) dispatch(closeModal())
    }

    const onSave = () => {
        setConfirmState(PENDING)

        LoadUserById(userData.userId)
        .then((user) => {
            if (user.password !== EncryptUserPassword(oldPassword)) {
                setOldPasswordWrong(true)
                setConfirmState(IDLE)
                return
            }
            setOldPasswordWrong(false)

            const mismatch = newPassword !== repeatNewPassword
            const correctRestrictions = CheckPasswordRestrictions(newPassword)
            setPasswordMismatch(mismatch)
            setPasswordRestrictions(correctRestrictions)

            if (mismatch || !correctRestrictions) {
                setConfirmState(IDLE)
                return
            }
            setPasswordMismatch(false)
            setPasswordRestrictions(true)

            ChangeUserPassword(user.id, newPassword)
            .then(() => {
                setConfirmState(IDLE)
                onClose()
            })
        })
    }

    const allowConfirm = oldPassword.length && newPassword.length && repeatNewPassword.length

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.changePassword}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.oldPassword}</Label>
                                <Input type="password" value={oldPassword} onChange={setOldPassword} />
                                <Feedback>{oldPasswordWrong && lang.oldPasswordWrong}</Feedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.newPassword}</Label>
                                <Input type="password" value={newPassword} onChange={setNewPassword} />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.repeatNewPassword}</Label>
                                <Input type="password" value={repeatNewPassword} onChange={setRepeatNewPassword} />
                                <Feedback>{passwordMismatch && lang.passwordMismatch}</Feedback>
                                <Feedback>{!passwordRestrictions && lang.passwordRestrictions}</Feedback>
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button
                                variant="success"
                                row
                                disabled={!allowConfirm}
                                onClick={onSave}
                            >
                                {confirmState === PENDING ? <SpinnerIcon /> : lang.confirm}
                            </Button>
                            <Button row onClick={onClose}>{lang.cancel}</Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default ChangePassword
